export default new class AgeCheckService {
    checkAge(fechaNacimiento, edadMinima, edadMaxima) {
        if (!fechaNacimiento) {
            return { success: false, message: "Error: La fecha de nacimiento es inválida o está vacía." };
        }

        let fechaNacimientoDate;
        if (typeof fechaNacimiento === "string") {
            const partes = fechaNacimiento.split("/");
            if (partes.length === 3) {
                fechaNacimientoDate = new Date(`${partes[1]}/${partes[0]}/${partes[2]}`);
            } else {
                fechaNacimientoDate = new Date(fechaNacimiento);
            }
        } else {
            fechaNacimientoDate = new Date(fechaNacimiento);
        }

        if (isNaN(fechaNacimientoDate.getTime())) {
            return { success: false, message: "Error: La fecha de nacimiento no es válida." };
        }

        const hoy = new Date();
        let edad = hoy.getFullYear() - fechaNacimientoDate.getFullYear();
        const mesDiferencia = hoy.getMonth() - fechaNacimientoDate.getMonth();
        const diaDiferencia = hoy.getDate() - fechaNacimientoDate.getDate();

        // Ajustar edad si aún no ha pasado el cumpleaños este año
        if (mesDiferencia < 0 || (mesDiferencia === 0 && diaDiferencia < 0)) {
            edad--;
        }

        if (edad < edadMinima) {
            return { success: false, message: `Error: La persona es menor de ${edadMinima} años (Edad: ${edad})` };
        } else if (edad > edadMaxima) {
            return { success: false, message: `Error: La persona es mayor de ${edadMaxima} años (Edad: ${edad})` };
        } else {
            return { success: true, message: `OK: La persona tiene ${edad} años.` };
        }
    }
}